export enum PastOrFuture {
    Future,
    Past
}